var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"puriifer"},[_c('router-link',{attrs:{"to":_vm.purifier.detailPage()}},[_c('h2',[_vm._v(_vm._s(_vm.purifier.name))]),_vm._v(" "),_c('purifier-image',{attrs:{"purifier":_vm.purifier}}),_vm._v(" "),_c('button',[_vm._v("Learn More")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25303020","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurifierView.vue
// module id = null
// module chunks = 